import { render, staticRenderFns } from "./NotificationsBloc.vue?vue&type=template&id=d9938116&"
import script from "./NotificationsBloc.vue?vue&type=script&lang=ts&"
export * from "./NotificationsBloc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports